import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../../services/AuthService';
import { AuthorizeRouteProps } from './AuthorizeRoute.model';

const AuthorizeRoute = ({ element }: AuthorizeRouteProps) => {
  const [ready, setReady] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  const populateAuthenticationState = async () => {
    const nextAuthenticated = await authService.isAuthenticated();
    setReady(true);
    setAuthenticated(nextAuthenticated);
  };

  const authenticationChanged = async () => {
    setReady(false);
    setAuthenticated(false);
    await populateAuthenticationState();
  };

  useEffect(() => {
    const subscription = authService.subscribe(() => authenticationChanged());
    populateAuthenticationState().then();

    return () => {
      authService.unsubscribe(subscription);
    };
  }, []);

  if (!ready) {
    return <div></div>;
  }

  return authenticated ? element : <Navigate replace to="/" />;
};

export default AuthorizeRoute;
